import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { CampaignComparisonApiService } from 'src/services/campaignComparisonApi'

// The account's saved comparisons. No polling, unlike the Data Comparison list:
// a comparison is a definition, complete the moment it is created, so there is
// no run to watch.
export const useGetCampaignComparisonsQuery = () =>
  useQuery({
    queryFn: () => CampaignComparisonApiService.getList(),
    queryKey: [QueryKey.GET_CAMPAIGN_COMPARISONS],
  })
